import React from 'react'
import PropTypes from 'prop-types'
import { isNilEmpty } from 'Utils'
import { propertyUseQuery, propertyQueryFn } from 'Services/reactQuery'
import NearbySchools from './index'

export const useFetchNearbySchoolBoundary = ({ areashapeKeys, latitude, longitude }) => propertyUseQuery(
  ['NearbySchool', latitude, longitude],
  propertyQueryFn({
    url: 'area-shape/inbound',
    reqData: {
      data: {
        areashape_keys: areashapeKeys,
        longitude,
        latitude,
      },
    },
  }),
  {
    enabled: (Boolean(latitude) && Boolean(longitude) && !isNilEmpty(areashapeKeys)),
    cacheTime: 1000 * 60,
    staleTime: 1000 * 60,
  },
)

const NearbySchoolsApiContainer = ({ schools, address, ...props }) => {
  const catchmentArray =
    schools
      ?.map(school => school.catchment)
      .filter(catchment => catchment !== null && catchment !== undefined) || []
  const { data: schoolBoundaryData, isFetching } = useFetchNearbySchoolBoundary({
    areashapeKeys: catchmentArray,
    longitude: address?.lng,
    latitude: address?.lat,
  })

  return (
    <NearbySchools
      schools={schools}
      address={address}
      schoolBoundaryData={schoolBoundaryData}
      isFetching={isFetching}
      {...props}
    />
  )
}

NearbySchoolsApiContainer.propTypes = {
  schools: PropTypes.arrayOf(PropTypes.shape({})),
  address: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number,
  }),
}

export default NearbySchoolsApiContainer
